export default __webpack_public_path__ + "static/media/OPENMAPS.93c02a0b.png";